module.exports = __webpack_public_path__ + "static/media/office3.5966fd14.png";